enum PurposeOfRemittance {
  COMPUTER_SERVICES = 'COMPUTER_SERVICES',
  MAINTENANCE_EXPENSES = 'MAINTENANCE_EXPENSES',
  SMALL_VALUE_REMITTANCE = 'SMALL_VALUE_REMITTANCE',
  LIBERALIZED_REMITTANCE = 'LIBERALIZED_REMITTANCE',
  CONSTRUCTION_EXPENSES = 'CONSTRUCTION_EXPENSES',
  HOTEL_ACCOMMODATION = 'HOTEL_ACCOMMODATION',
  ADVERTISING_EXPENSES = 'ADVERTISING_EXPENSES',
  ADVISORY_FEES = 'ADVISORY_FEES',
  BUSINESS_INSURANCE = 'BUSINESS_INSURANCE',
  INSURANCE_CLAIMS = 'INSURANCE_CLAIMS',
  DELIVERY_FEES = 'DELIVERY_FEES',
  EXPORTED_GOODS = 'EXPORTED_GOODS',
  SERVICE_CHARGES = 'SERVICE_CHARGES',
  LOAN_PAYMENT = 'LOAN_PAYMENT',
  OFFICE_EXPENSES = 'OFFICE_EXPENSES',
  PROPERTY_PURCHASE = 'PROPERTY_PURCHASE',
  PROPERTY_RENTAL = 'PROPERTY_RENTAL',
  ROYALTY_FEES = 'ROYALTY_FEES',
  SHARES_INVESTMENT = 'SHARES_INVESTMENT',
  FUND_INVESTMENT = 'FUND_INVESTMENT',
  TAX_PAYMENT = 'TAX_PAYMENT',
  TRANSPORTATION_FEES = 'TRANSPORTATION_FEES',
  UTILITY_BILLS = 'UTILITY_BILLS',
  PERSONAL_TRANSFER = 'PERSONAL_TRANSFER',
  REWARD_PAYMENT = 'REWARD_PAYMENT',
  INFLUENCER_PAYMENT = 'INFLUENCER_PAYMENT',
  OTHER_FEES = 'OTHER_FEES',
  OTHER = 'OTHER',
}

export default PurposeOfRemittance;
